import React from "react";

import { HStack } from "../../../primitive";
import { Input } from "../../Input";
import { PhoneInputProps } from "../../Input/types";
import { usePhoneInput } from "../hooks/usePhoneInput";
import { CountryCodes } from "../utils/countryCodes";
import { CountryCodeSelector } from "./CountryCodeSelector";

export const PhoneInput = ({
  testID,
  name,
  placeholder,
  hasError,
  isDisabled,
  isViewOnly,
  onChange,
  onCountryCodeChange,
  inputRef,
  nationalNumber,
  defaultCountryId,
  onKeyPress,
}: PhoneInputProps) => {
  const {
    countryCode,
    handleCountryCodeChange,
    handleChange,
    maskPhoneNumber,
  } = usePhoneInput({
    onChange,
    defaultCountryId,
    onCountryCodeChange,
  });

  return (
    <HStack gap={2} alignItems="center">
      <Input<"text">
        name={name}
        testID={testID}
        // Mask the phone number
        value={maskPhoneNumber(nationalNumber, countryCode.regionCode) || ""}
        onChange={handleChange}
        isDisabled={isDisabled}
        isViewOnly={isViewOnly}
        hasError={hasError}
        placeholder={placeholder}
        inputRef={inputRef}
        keyboardType="phone-pad"
        onKeyPress={onKeyPress}
        leftIcon={
          <CountryCodeSelector
            countryCodes={CountryCodes}
            countryCode={countryCode}
            setCountryCode={handleCountryCodeChange}
            isDisabled={isViewOnly || isDisabled}
            variant="default"
          />
        }
        hideIconWrapper
      />
    </HStack>
  );
};
